const palette = {
  primary: {
    main: "#168BFF",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#94A3B8",
  },
  background: {
    default: "#060D18",
    paper: "#0B1424",
  },
  text: {
    primary: "#F8FAFC",
    secondary: "#94A3B8",
  },
};

export default palette;
